<div class="content">
    <p class="m-0 mt-2 mb-4">
        Before continuing to the dashboard, you have to choose a plan. Select a plan from one of the options below.
    </p>

    <div *ngIf="isLoadingPlans; else plansTemplate">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>

    <ng-template #plansTemplate>
        <div class="row g-4 row-cols-1 row-cols-md-2 row-cols-lg-4">
            <ng-container *ngIf="!isSubscriptionLoading">
                <ng-container *ngFor="let plan of subscriptionPlans">
                    <div class="col d-flex flex-column">
                        <div class="card border border-1 rounded-3 cursor-pointer h-100"
                            [class.border-primary]="selectedPlan && plan.id === selectedPlan.id"
                            (click)="onPlanSelected(plan)">

                            <div class="card-body">
                                <h4 class="card-title text-truncate pb-1">{{plan?.title}}</h4>
                                <span class="text-muted"
                                    style="word-wrap: nowrap; display: flex; overflow: hidden; font-size: 14px; line-height: calc(14px * 1.4); height: calc(14px * 1.4 * 6);"
                                    [innerHTML]="plan.description | urlDecoder">
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <div *ngIf="isSubscriptionLoading" class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div class="flex justify-content-start align-items-start m-0 pt-4 mt-4 ms-1"
            style="border-top: 1px solid #ddd;">
            <div class="m-0" style="font-size: 14px; line-height: 1.5; list-style: none;">
                <div class="py-1">
                    <h5>Included in every plan</h5>
                </div>
                <div>- Free Trial</div>
                <div>- Pay only for software</div>
                <div>- Deploy inside your subscription (No VNET Peering)</div>
                <div>- Fully automated deployment with Azure PowerShell</div>
                <div>- Download and deploy yourself</div>
            </div>
        </div>
    </ng-template>
</div>

<div class='footer'>
    <button class="btn btn-sm btn-nc btn-outline-primary az-btn-space btn-width" [disabled]="true">
        Previous
    </button>

    <button class="btn btn-nc az-btn-space btn-sm submit btn-primary btn-width" (click)="onNext()"
        [disabled]="!isNextAllowed()">
        Next
    </button>
    <button class="btn btn-sm btn-nc btn-outline-primary az-btn-space btn-width" (click)="goToDashboard()">
        Cancel
    </button>
</div>